import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import QRCode from "react-qr-code";
import { AlertTriangle } from "lucide-react";

export function QRDialog({ open, onOpenChange, venueId, eventId }) {
  const scoreboardUrl = `${window.location.origin}/scoreboard${venueId ? `?v=${venueId}` : ""}`;
  const joinUrl = eventId ? `${window.location.origin}/join/${eventId}` : null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#141414] border-white/10 rounded-none max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-heading text-white text-xl text-center">QR Codes</DialogTitle>
        </DialogHeader>
        <Tabs defaultValue={joinUrl ? "join" : "scoreboard"} className="w-full">
          <TabsList className="w-full bg-transparent border border-white/10 rounded-none h-9 p-0">
            <TabsTrigger value="join" className="flex-1 rounded-none data-[state=active]:bg-[#E3292E] data-[state=active]:text-white text-white/50 text-xs font-heading h-full" data-testid="qr-tab-join">
              Player Join
            </TabsTrigger>
            <TabsTrigger value="scoreboard" className="flex-1 rounded-none data-[state=active]:bg-[#E3292E] data-[state=active]:text-white text-white/50 text-xs font-heading h-full" data-testid="qr-tab-scoreboard">
              Scoreboard
            </TabsTrigger>
          </TabsList>
          <TabsContent value="join" className="mt-4">
            {joinUrl ? (
              <div className="flex flex-col items-center gap-4">
                <div className="bg-white p-4">
                  <QRCode value={joinUrl} size={200} data-testid="qr-join-code" />
                </div>
                <p className="text-white/50 text-sm font-body text-center">Players scan to join the game from their phone</p>
                <p className="text-white/30 text-xs font-body text-center break-all select-all">{joinUrl}</p>
              </div>
            ) : (
              <div className="flex flex-col items-center gap-4 py-6">
                <AlertTriangle className="h-8 w-8 text-yellow-400" />
                <p className="text-white/50 text-sm font-body text-center">Create an event first to generate a Player Join QR code.</p>
              </div>
            )}
          </TabsContent>
          <TabsContent value="scoreboard" className="mt-4">
            <div className="flex flex-col items-center gap-4">
              <div className="bg-white p-4">
                <QRCode value={scoreboardUrl} size={200} data-testid="qr-scoreboard-code" />
              </div>
              <p className="text-white/50 text-sm font-body text-center">Scan to view the live scoreboard</p>
              <p className="text-white/30 text-xs font-body text-center break-all select-all">{scoreboardUrl}</p>
            </div>
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
